import { IonContent } from "@ionic/react";

import { BackToolbarComponent } from "@/components/toolbar/back-toolbar";
import StepToolbarComponent from "@/components/toolbar/step-toolbar";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { cn } from "@/utils/cn";
import { IonPage } from "@ionic/react";
import { ReactNode } from "react";

interface ProfilePageContainerProps {
  children: ReactNode;
  className?: string;
  showToolbar?: boolean;
  actionButton?: React.ReactNode;
}

export const ProfilePageContainer = ({
  children,
  className,
  showToolbar = true,
  actionButton,
}: ProfilePageContainerProps) => {
  const { info, totalSteps } = useStepRouteInfo();

  const getToolbar = () => {
    if (!showToolbar) return null;
    if (info?.step) {
      return (
        <StepToolbarComponent
          totalStep={totalSteps}
          progress={info?.step ? info.step / totalSteps : 0}
        />
      );
    }
    return <BackToolbarComponent actionButton={actionButton} />;
  };
  return (
    <IonPage>
      {getToolbar()}
      <IonContent fullscreen>
        <div
          className={cn(
            "flex flex-col items-center gap-4 justify-start self-center w-full max-w-[420px] mx-auto h-full",
            className,
          )}
        >
          {children}
        </div>
      </IonContent>
    </IonPage>
  );
};
